import {
  agDepartmentsCol,
  agDetailCol,
  agEndDateCol,
  agInvoicePaidCol,
  agInvoiceReceivedCol,
  agOrderPlacedCol,
  agPriceCol,
  agStartDateCol,
  agStatusCol,
  licenseCol,
  exchangeRateCol,
  priceChangeCol
} from '@/ag-grid/ag-columns'
import { getProp } from '@lib/generic.utils'
import { notAnyPriceCheck, notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
import * as shared from '@/modules/list-view-subscriptions/shared/ag-grid-columns'
import { metadataColDefs } from '@/utils/metadataColDefs'

export default {
  computed: {
    metadataColDefs,

    columnDefs() {
      return [
        agStatusCol(),

        {
          ...shared.subscriptionsCol(),
          cellRendererFramework: 'LinkRenderer',
          cellRendererParams: params => {
            return {
              route: `/subscriptions/${params.data.subscription.id}`
            }
          }
        },

        {
          ...shared.productTypeCol(),
          cellRenderer: params => notAnyValueCheck({ ...params, value: params.data.product_type?.name })
        },

        {
          ...shared.publisherCol(),
          valueGetter: params => params?.data?.publisher?.name || 'N/A',
          cellRendererFramework: 'LinkRenderer',
          cellRendererParams: params => {
            return {
              route: `/publishers/${params.data.publisher.id}`
            }
          }
        },

        {
          ...shared.vendorCol(),
          valueGetter: params => params?.data?.vendor?.name || 'N/A',
          cellRendererFramework: 'LinkRenderer',
          cellRendererParams: params => {
            return {
              route: `/vendors/${params.data.vendor.id}`
            }
          }
        },

        agStartDateCol(shared.cancellationDeadlineCol()),

        agStartDateCol(),

        agEndDateCol(),

        agDetailCol({ hide: false }),

        shared.publisherReferenceCol(),

        shared.libraryReferenceCol(),

        {
          ...shared.licenseManagerCol(),
          cellRenderer: params => {
            if (!params.data) return
            return getProp(params.data.owner, 'name')
          }
        },

        agPriceCol('List Price', 'list_price', { hide: true }),

        agPriceCol('First Offer Price', 'first_offer_price', { hide: true }),

        agPriceCol('Forecasted Price', 'forecasted_price', { hide: true }),

        agPriceCol('Forecasted Local Price', 'forecasted_local_price', {
          hide: true,
          cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency')
        }),

        agPriceCol('Price', 'price'),

        agPriceCol('Local Price', 'normalized_price', {
          cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency')
        }),

        exchangeRateCol({ editable: false, cellClass: ['ag-right-aligned-cell'], hide: true }),

        agOrderPlacedCol(),

        agInvoiceReceivedCol(),

        agInvoicePaidCol(),

        licenseCol(),

        {
          ...shared.stakeholdersCol(),
          cellRenderer: params => {
            if (!params.value.length) return `N/A`

            const names = params.value.map(val => val.name)
            return `(${params.value.length}) ${names.join(',')}`
          }
        },

        agPriceCol('Usage', 'usage', { hide: true, cellRenderer: notAnyValueCheck }),

        agPriceCol('CPU Original Price', 'cost_per_use_original', { hide: true, maxWidth: 120 }),

        agPriceCol('CPU Local Price', 'cost_per_use_local', {
          cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency'),
          maxWidth: 100,
          hide: true
        }),

        agDepartmentsCol(
          'lv-subscriptions',
          {
            headerName: this.departmentLabel.plural,
            hide: true
          },
          {
            optionsModule: 'lv-subscriptions'
          }
        ),

        shared.costCentersCol(),

        shared.financialPeriod(),

        priceChangeCol()
      ]
    },

    gridOptions() {
      return {
        columnDefs: [...this.columnDefs, ...this.metadataColDefs],

        defaultColDef: {
          floatingFilter: true
        },

        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
